export default __webpack_public_path__ + "static/media/BuddyCropped.8f9bc7c1.gif";